<template>
  <div class="container-full flex-wrap" style="align-items:stretch;height:100%;overflow:hidden;position:relative;">
    <div style="width:200px;border-right:1px solid var(--border)">
        <BaseMenu :menus="items" :actived="actived" @on-click="handleClick" />
    </div>
    <div style="width:calc(100% - 200px);height:100%;overflow:hidden;position:relative;">
        <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  routerOption: {
    as_frame: true,
  },
  computed: {
    actived() {
      return this.$route.path.slice(this.$route.path.lastIndexOf('/')+1);
    },
    session() {
      return this.$store.getters['session/session'];
    },
    items() {
      const normal = [{
        icon: 'ios-eye',
        name: '视图数据',
        key: 'view',
      }, {
        icon: 'ios-git-merge',
        name: '阶段数据',
        key: 'phase',
      }, {
        icon: 'ios-folder-open',
        name: '模块数据',
        key: 'work',
      }, {
        icon: 'ios-calendar',
        name: '时间数据',
        key: 'daily',
      }, {
        icon: 'ios-checkmark-circle-outline',
        name: '工作检查',
        key: 'inspect',
      }, {
        icon: 'ios-list-box',
        name: '任务数据',
        key: 'task',
      }, {
        icon: 'ios-pricetags',
        name: '分类数据',
        key: 'category',
      }, {
        icon: 'ios-people',
        name: '岗位数据',
        key: 'person',
      }, {
        icon: 'ios-construct',
        name: '自建任务',
        key: 'untemplated',
      }, {
        icon: 'ios-images',
        name: '图片库',
        key: 'images',
      }];
      const mgr = [{
        icon: 'ios-stats',
        name: '管理数据',
        key: 'mgr',
      }, {
        icon: 'ios-document',
        name: '模板任务',
        key: 'maindep',
      }];
      let items = [...normal];
      if (this.session.roles && this.session.roles.filter((v)=>v.name && v.name.includes('事业部')).length > 0) {
        items = items.concat(mgr);
      }
      return items;
    },
  },
  methods: {
    handleClick(e) {
      this.RouteTo(e);
    },
  },
};
</script>

<style>

</style>
